import React from "react";
import { ToolCardShell, type CardStatus } from "../tool";
import { ToolInput, ToolOutput } from "../tool";
import type { ToolCardComponentProps } from "../tool-registry";

export type ToolCardFallbackProps = ToolCardComponentProps;

export const ToolCardFallback: React.FC<ToolCardFallbackProps> = ({ toolCall }) => {
  const cardStatus: CardStatus = toolCall.status || "detected";

  return (
    <ToolCardShell
      toolName={toolCall.toolName}
      status={cardStatus}
      defaultExpanded={cardStatus === "failed"}
    >
      {toolCall.args && Object.keys(toolCall.args).length > 0 && (
        <ToolInput data={toolCall.args} />
      )}
      {(toolCall.result !== undefined && toolCall.result !== null) || toolCall.error ? (
        <ToolOutput data={toolCall.result} error={toolCall.error} />
      ) : null}
    </ToolCardShell>
  );
};
